import React, {PropTypes} from 'react';
import {
  DropdownButton, 
  MenuItem
} from 'react-bootstrap';

const UserLogin = ({
  username,
  isLoggedIn,
  onLoginClick,
  onUserClick,
  onLogoutClick,
  onPartnerLoginClick,
  groupName,
  isAllowed
}) => {
  return (
    <div className="user-login banner-flex-right">
      {
        isLoggedIn
        ?
          <div> 
            <div className="banner-flex-right">
              <DropdownButton id={`actions-dropdown-UserDropDown`}        
                            className="btn btn-link"                            
                            title={`Welcome ${username}`}>
                {
                  isAllowed && groupName && window.GROUP_ENABLED === "true"
                  ? <MenuItem className="entry-dropdown-link" 
                      disabled>
                      {groupName}
                    </MenuItem>
                  : null
                }
                {
                  isAllowed && groupName && window.GROUP_ENABLED === "true" 
                  ? <MenuItem divider />
                  : null
                }
                <MenuItem className="entry-dropdown-link"
                  onSelect={onUserClick}>
                  {'Edit Profile'}
                </MenuItem>
                <MenuItem className="entry-dropdown-link"
                  onSelect={onLogoutClick}>
                  {'Logout'}
                </MenuItem> 
                <MenuItem divider />
                <MenuItem className="entry-dropdown-link" onSelect={onPartnerLoginClick}>
                  {'Partner Hub Login'}
                </MenuItem>
              </DropdownButton>
            </div>   
          </div>
        : <button
            className="btn btn-link banner-flex-right"
            onClick={onLoginClick}>{'Login'}</button>
      }
    </div>
  );
};

UserLogin.propTypes = {
  username: PropTypes.string,
  isLoggedIn: PropTypes.bool,
  onLoginClick: PropTypes.func,
  onUserClick: PropTypes.func,
  onLogoutClick: PropTypes.func,
  onPartnerLoginClick: PropTypes.func,
  groupName: PropTypes.string
};

export default UserLogin;



// WEBPACK FOOTER //
// ./src/features/shared/topBanner/UserLogin.jsx